import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { BodyCargaPlanes } from 'src/app/interfaces/body_cargaPlanes';
import { BodyEnvioPlanes } from 'src/app/interfaces/body_envioPlanes';
import { DatosGeneralesModel } from 'src/app/models/datosGenenrales';

@Component({
  selector: 'app-info-mensaje-no',
  standalone: false,
  templateUrl: './info-mensaje-no.component.html',
  styleUrl: './info-mensaje-no.component.scss'
})
export class InfoMensajeNoComponent implements OnInit {

  private datosGenerales: DatosGeneralesModel = {
    Cliente: {
      cedulaCliente: '',
      celularCliente: '',
      nombreCliente: '',
      tipoIdentificacion: ''
    },
    InfoArrendamiento: {
      tipoPropiedad: '',
      ubicacion: '',
      valorAdministracion: 0,
      valorArriendo: 0,
      fechaContrato: '',
      duracionContrato: '',
      ServiciosPublicos: false,
      PaquetesAsistencia: false
    },
    Propietario: {
      primerNombre: '',
      segundoNombre: '',
      primerApellido: '',
      segundoApellido: '',
      paisNacimiento: '',
      tipoIdentificacion: '',
      numeroIdentificacion: '',
      fechaExpedicion: '',
      correo: ''
    },
    PlanSeleccionado: {
      plan: '',
      valorPlan: 0
    },
    Inmueble: {
      ciudad: '',
      direccion: '',
      maticula: ''
    },
    Inquilino: {
      primerNombre: '',
      segundoNombre: '',
      primerApellido: '',
      segundoApellido: '',
      numCelular: '',
      correo: '',
      paisNacimento: '',
      fechaNacimento: '',
      tipoidentificacion: '',
      documentoIdentidad: '',
      fechaExpedicion: '',
      ciudad: '',
      direccion: ''
    },
    ResponseRiesgoConsultable: [
      {
        esRiesgo: false,
        tipoValidacion: '',
        mensajeValidacion: '',
        idRegistroValidacion: ''
      }
    ]
  }

  json: string = '';
  jsonFinal: string = '';

  dataEnvio: BodyEnvioPlanes = {
    SessionId: '',
    productFamily: '',
    leadId: '',
    asesorCode: '',
    bitacoraId: '',
    screenPercentage: '',
    productsConfigurationData: {
      ProductCode: '',
      PolicyHolder: {
        LastName: '',
        MobilePhone: '',
        PersonalDataAuthorization: false
      },
      Tenant: {
        DocumentNumber: '',
        DocumentType: ''
      },
      Property: {
        TemporaryContracted: '',
        ContractStartDate: '',
        AdministrationValue: 0,
        RentalFee: 0,
        Department: '',
        UseProperty: ''
      }
    }
  };

  dataCarga: BodyCargaPlanes = {
    getPriceData: false,
    productsConfigurationData: {
      Property: {
        AdministrationValue: 0,
        Department: '',
        RentalFee: 0,
        TemporaryContracted: ''
      }
    }
  };

  parametro: string = '';
  sessionId: string = '';
  leadId: string = '';
  codAsesor: string = '';
  IdBitacora: string = '';
  precioCanon: number = 0;
  segundoCanon: number = 0;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
  ) { }


  @Input() infoCliente?: string;
  @Input() idLead?: string;

  ngOnInit(): void {
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.leadId = params.getAll('idLead')[0];
      const resultado = params.get('infoCliente');
      this.codAsesor = params.getAll('codigoAsesor')[0];
      this.IdBitacora = params.getAll('bitacoraId')[0];

      if (resultado !== null) {
        this.json = resultado;
        this.jsonFinal = atob(this.json);
        this.datosGenerales = JSON.parse(this.jsonFinal);
        this.parametro = JSON.stringify(this.datosGenerales);
        
        this.precioCanon = (this.datosGenerales.InfoArrendamiento.valorArriendo + this.datosGenerales.InfoArrendamiento.valorAdministracion) * 0.5;
        const porceCanon = (this.datosGenerales.InfoArrendamiento.valorArriendo + this.datosGenerales.InfoArrendamiento.valorAdministracion) * 0.35;
        this.segundoCanon = porceCanon;
      }
      else {
        const paramInfoCliente = this.infoCliente;
        const paramIdLead = this.idLead;
        this.leadId = paramIdLead !== undefined ? paramIdLead : '';

        if (paramInfoCliente !== undefined) {
          this.json = paramInfoCliente;
          this.jsonFinal = atob(this.json);
          this.datosGenerales = JSON.parse(this.jsonFinal);
          this.parametro = JSON.stringify(this.datosGenerales);

          this.precioCanon = (this.datosGenerales.InfoArrendamiento.valorArriendo + this.datosGenerales.InfoArrendamiento.valorAdministracion) * 0.5;
        const porceCanon = (this.datosGenerales.InfoArrendamiento.valorArriendo + this.datosGenerales.InfoArrendamiento.valorAdministracion) * 0.35;
        this.segundoCanon = porceCanon;
        }
      }
    });
  }

}
